import axios from 'axios';
import { API_URL } from 'src/api';

export const fetcher = <TData, TVariables>(
  query: string,
  variables?: TVariables,
) => {
  return async (): Promise<TData> => {
    const res = await axios(`${API_URL}/graphql` as string, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: { query, variables },
    });
    if (res.data?.errors?.length) {
      const { message, extensions } = res.data.errors[0];
      const error = new Error(message);
      // Preserve the GraphQL error code so callers can branch on it reliably
      // instead of matching on the human-readable message text.
      if (extensions?.code) {
        (error as Error & { code?: string }).code = extensions.code;
      }
      throw error;
    }
    return res.data.data;
  };
};
